import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { DateTimePickerInputs, OpoSelectors } from '@features/components/CaseFormBlocks/components';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { useCaseDetailsSafe } from '@/hooks/useCaseDetailsSafe';
import { DonorHospitalSelector } from './components';
import { getDonorOrRequired, isDirectAcquisitionCase } from './utils';

export type CaseDonorProps = {
  disabled?: Partial<Record<keyof CaseFormType, boolean>>;
  hasPermission?: boolean;
  isEditModal?: boolean;
};

export const CaseDonor = memo(({ disabled, hasPermission, isEditModal = false }: CaseDonorProps) => {
  const { control } = useFormContext<CaseFormType>();

  const [reAllocationCaseIdForm, serviceTypeForm, statusForm] = useWatch({
    control,
    name: ['reAllocationCaseId', 'serviceType', 'status'],
  });

  const caseDetails = useCaseDetailsSafe();

  const serviceTypeInfo = isEditModal ? caseDetails?.serviceType : serviceTypeForm;
  const reAllocationCaseIdInfo = isEditModal ? caseDetails?.reAllocationCaseId : reAllocationCaseIdForm;
  const statusInfo = isEditModal ? caseDetails?.status : statusForm;

  const isDaCase = isDirectAcquisitionCase(serviceTypeInfo);
  const donorOrRequired = getDonorOrRequired({
    serviceType: serviceTypeInfo,
    status: statusInfo,
  });
  const allowPast = !!reAllocationCaseIdInfo || isDaCase;

  return (
    <>
      <DonorHospitalSelector disabled={disabled} hasPermission={hasPermission} isRequired={!isDaCase} />
      <OpoSelectors disabled={disabled} showRequired={!isDaCase} hasPermission={hasPermission} />
      <DateTimePickerInputs
        isRequired={donorOrRequired}
        disabledDate={disabled?.donorHospitalDate}
        disabledTime={disabled?.donorHospitalTime}
        disabledTimezone={disabled?.donorHospitalTimeZone}
        disabledPast={!allowPast}
        control={control}
        title="Donor OR"
        dateFieldName="donorHospitalDate"
        dateFieldLabel="Select OR Date"
        timeFieldName="donorHospitalTime"
        timeFieldLabel="Select OR Time"
        timeZoneFieldName="donorHospitalTimeZone"
        hasPermission={hasPermission}
      />
    </>
  );
});
